import Vue from 'vue';
import extendInstall from '../lang/extendInstall';

Vue.use(extendInstall);
